import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const updateProfile = async (
  userId,
  payload,
  setLoading,
  setRefresh,
  onClose
) => {
  try {
    setLoading(true);
    await http.post(AUTH_ROUTES.UPDATE_USER(userId), payload);
    setLoading(false);
    // console.log(data, "login");
    successNotifier("Profile successfully updated");
    onClose();

    setRefresh(false);
    // return data;
  } catch (e) {
    setLoading(false);
    console.log("error updating", e?.response);
    // The backend's message field is sometimes an array (e.g. ["Invalid old
    // password"]) and sometimes a plain string (its generic catch-all) —
    // indexing [0] on a string silently truncated the toast to one
    // character. Handle both shapes.
    const message = e?.response?.data?.user?.message;
    errorNotifier(
      Array.isArray(message)
        ? message[0]
        : message || "Something went wrong. Please try again.",
    );
    setRefresh(false);
  }
};
